module.exports = __webpack_public_path__ + "static/media/product-7.3b5d028b.jpg";